export default "__VITE_ASSET__DKp_l4hJ__"